const CLIENT_ACTIONS = {
    VIEW: {
        text: 'details',
        icon: 'mdi-eye',
        route: 'clientDetails'
    },
    AUTORIZATIONS:{
        icon: 'mdi-file-check',
        route: 'clientAuthorizationAssignment'
    },
    EDIT_DOCUMENTS: {
        text: 'edit-document-files',
        icon: 'fa-file-alt',
        route: 'clientDocumentFilesEdit'
    },
    ADD_DOCUMENTS: {
        text: 'add document files',
        icon: 'fa-file-alt',
        route: 'clientDocumentFilesAdd'
    },
    EDIT: {
        text: 'edit',
        icon: 'ub-employee',
        route: 'clientEdit'
    },
    DELETE:{
        text: 'delete',
        icon: 'mdi-delete'
    },
    ADD:{
        route: 'clientAdd'
    }
};

export {
    CLIENT_ACTIONS,
}